import { HashLink } from 'react-router-hash-link';
import { useAppDispatch, useAppSelector } from 'store';
import BaseButton from 'components/atoms/baseButton';
import CloseIcon from 'components/atoms/icons/closeIcon';
import classNames from 'classnames';
import { useMemo, type FC } from 'react';

import s from './styles.module.scss';
import { useMiniNav } from '../hooks/use-mini-nav';

import type { IRpmActivityCountResponse } from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { ModuleType } from 'infrastructure/enums';

interface MobileMiniNavProps {
  module: ModuleType;
  activityCount?: IRpmActivityCountResponse;
}

const scrollWithOffset = (el: HTMLElement, callBack: () => void) => {
  const yCoordinate = el.getBoundingClientRect().top + window.scrollY;
  const yOffset = -110; // header + mini banner height
  window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  callBack();
};

const MobileMiniNav: FC<MobileMiniNavProps> = ({ module, activityCount }) => {
  const isOpen = useAppSelector(
    (store) => store.modalWindows.isMobileMiniNavOpen,
  );
  const {
    modalWindows: { toggleOpenMobileMiniNav },
  } = useAppDispatch();
  const { linksList, generateLinksWithIndicators } = useMiniNav();

  const links = useMemo(
    () => generateLinksWithIndicators(linksList, module, activityCount),
    [linksList, module, activityCount],
  );

  return isOpen ? (
    <div className={s.wrapper}>
      <div className={s.links}>
        {links?.map((link) => (
          <HashLink
            smooth
            to={link.to}
            scroll={(el) => scrollWithOffset(el, toggleOpenMobileMiniNav)}
            key={link.key}
          >
            <div
              className={classNames(
                s.item,
                link.iconColor && s[link.iconColor],
                {
                  [s.marked]: link.marked && link.iconColor,
                },
              )}
              data-cy={link.dataCy}
            >
              {link.icon}
              <p>{link.title}</p>
            </div>
          </HashLink>
        ))}
      </div>
      <BaseButton
        icon={<CloseIcon />}
        type="secondary"
        onClick={toggleOpenMobileMiniNav}
      />
    </div>
  ) : null;
};
export default MobileMiniNav;
